"use client";

const SERVICES = [
  {
    badge: "Dès 25 000 F",
    title: "Livraison Express",
    description:
      "Livraison en 2h dans Paris intramuros, 24h en Île-de-France. Suivi en temps réel, livreur dédié.",
  },
  {
    badge: "30 min",
    title: "Click & Collect",
    description:
      "Commandez en ligne, retirez en drive 30 min plus tard. Voiturier et chargement gratuits.",
  },
  {
    badge: "Gratuit",
    title: "Club OR Premium",
    description:
      "Cagnotage 3%, offres privées, conciergerie, accès au salon VIP, livraison illimitée.",
  },
  {
    badge: "3x sans frais",
    title: "Paiement Flexible",
    description:
      "Cartes bancaires, Orange Money, Wave, paiement en 3x sans frais dès 100 000 FCFA.",
  },
  {
    badge: "FR · EN · WO",
    title: "Conciergerie 7j/7",
    description:
      "Une équipe bilingue à votre écoute par téléphone, WhatsApp et en magasin, de 8h à 22h.",
  },
  {
    badge: "Net Zéro 2030",
    title: "OR Éco-Responsable",
    description:
      "Biodéchats compostés, sacs réutilisables offerts, programme de reprise des emballages.",
  },
];

export function ServicesSection() {
  return (
    <section id="services" className="relative bg-cream py-24 md:py-32 border-t border-ink/8">
      <div className="mx-auto max-w-7xl px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="ornament-line mb-6 justify-center">
            <span className="text-gold text-[11px] tracking-[0.35em] uppercase">
              Services OR
            </span>
          </div>
          <h2 className="font-display text-ink text-4xl md:text-6xl leading-[1.05]">
            Le luxe d&apos;être
            <br />
            <span className="gold-text italic">bien servi.</span>
          </h2>
          <p className="mt-6 text-ink/65 font-serif text-lg leading-relaxed">
            Hyper OR I vous accompagne à chaque étape, de la commande à la
            livraison, avec un sens du service digne des plus belles maisons.
          </p>
        </div>

        {/* 6 services */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {SERVICES.map((s, idx) => (
            <article
              key={idx}
              className="group relative bg-white border border-ink/8 rounded-xl p-6 hover:luxury-shadow transition-all duration-500 hover:-translate-y-0.5"
            >
              <div className="inline-block px-2.5 py-1 rounded-full text-[10px] tracking-[0.2em] uppercase font-semibold bg-gold/15 text-gold-dark mb-4">
                {s.badge}
              </div>
              <h3 className="font-display text-ink text-xl leading-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-ink/60 text-[13px] leading-relaxed font-serif">
                {s.description}
              </p>
            </article>
          ))}
        </div>

        {/* Club OR Premium block */}
        <div className="mt-12 relative overflow-hidden rounded-2xl bg-ink text-cream p-8 md:p-12">
          <div className="absolute inset-0 ink-gradient opacity-90"></div>
          <div
            className="absolute inset-0 opacity-30"
            style={{
              backgroundImage:
                "radial-gradient(circle at 80% 30%, rgba(200,162,74,0.4) 0%, transparent 60%)",
            }}
          ></div>
          <div className="relative grid md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-8">
              <div className="flex items-center gap-3 mb-4">
                <span className="h-px w-8 bg-gold"></span>
                <span className="text-gold text-[11px] tracking-[0.3em] uppercase">
                  Club OR Premium
                </span>
              </div>
              <h3 className="font-display text-cream text-3xl md:text-4xl leading-tight">
                Une carte. Un univers de{" "}
                <span className="gold-text italic">privilèges.</span>
              </h3>
              <p className="mt-4 text-cream/65 font-serif text-base leading-relaxed max-w-2xl">
                Cagnotage 3% sur tous vos achats, offres privées, salon VIP avec
                café et pâtisserie offerte, livraison illimitée et accès en
                avant-première aux ventes exceptionnelles.
              </p>
            </div>
            <div className="md:col-span-4 md:text-right">
              <a
                href="#newsletter"
                className="inline-flex items-center gap-3 px-8 py-4 rounded-full gold-gradient text-ink font-semibold tracking-[0.2em] uppercase text-sm gold-shadow hover:scale-[1.02] active:scale-[0.98] transition-transform"
              >
                Demander ma carte OR
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
